<div class="column left">{{key}}</div>
<div class="column right">{{value}}</div>
